var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8690fa",
    d: "M16 31a15 15 0 1 1 15-15 15 15 0 0 1-15 15Zm0-29a14 14 0 1 0 14 14A14 14 0 0 0 16 2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12,
    fill: "#cfd2fc"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(52.54902%,56.470588%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 8 16 L 10.667969 16 L 10.667969 22.667969 L 14.667969 22.667969 L 14.667969 18.667969 L 17.332031 18.667969 L 17.332031 22.667969 L 21.332031 22.667969 L 21.332031 16 L 24 16 L 16 8 Z M 8 16 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeButton);
export default __webpack_public_path__ + "static/media/home-button.6ad97712910a5c663e5f07a2f79c7595.svg";
export { ForwardRef as ReactComponent };